module.exports = {"id":"193226","name":"Benjamin Jeannot","rating":"72","photo":"./data/images/photos/3/193226.png","club":{"name":"Dijon FCO","logo":"./data/images/clubs/DijonFCO.png"},"positions":["BU","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BenjaminJeannot0.json
// module id = 570
// module chunks = 0